import {
  PropertiesContext,
  PropertiesContextType,
} from "@/contexts/PropertiesContext";
import { Select } from "@chakra-ui/react";
// import { SelectProps } from "@chakra-ui/react";
import { useContext } from "react";

export const StaysPropertiesSelect = () => {
  const { stProperties, selectedStaysProperty, setSelectedStaysProperty } =
    useContext<PropertiesContextType | undefined>(
      PropertiesContext
    ) as PropertiesContextType;

  return (
    <Select
      placeholder="Selecione a propriedade Stays"
      onChange={({ target: { value } }) => {
        const selectedStaysPropertyObject =
          stProperties.find((stProperty) => stProperty.id === value) ?? null;
        setSelectedStaysProperty(selectedStaysPropertyObject);
      }}
      value={selectedStaysProperty?.id ?? undefined}
    >
      {stProperties.map((stProperty) => (
        <option key={stProperty.id} value={stProperty.id}>
          {stProperty.internalname}
        </option>
      ))}
    </Select>
  );
};
